import React, { Dispatch, useEffect } from 'react'
import EventList from './EventList'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import * as routes from '../../routes'
import { EventModal } from './EventDetailModal'
import { FilterForm } from './EventFilter'
import { useNavigate, useParams } from 'react-router-dom'
import StageNavigation from '../shared/StageNavigation'
import { addToast } from '../../store/misc/misc'
import { ToastType } from '../../store/misc/interfaces'
import { createAction } from '@reduxjs/toolkit'
import { getFilteredEvents } from '../../store/events/selectors'
import { IRegistration } from '../../store/registrations/interfaces'

type EventStageParams = {
  eventId: string
}

const EventStage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { eventId } = useParams<EventStageParams>()

  const filteredEvents = useSelector(getFilteredEvents)
  const { list: regs } = useSelector((state: RootState) => state.registrations)
  const { data: program } = useSelector((state: RootState) => state.program)
  const { data: institution } = useSelector((state: RootState) => state.institution)

  useEffect(() => {
    // Update the document title using the browser API
    document.title = `${program.name}: Veranstaltungsübersicht | Feripro ${institution.name}`
  })

  const hasRegistration = regs.some((reg: IRegistration) => (!!reg.event.event_id))

  return (
    <>
      <h2 aria-level={1}>
        {program.name}: Veranstaltungen auswählen
      </h2>
      <FilterForm />
      <EventList />
      {eventId && (
        <EventModal
          eventId={parseInt(eventId)}
          events={filteredEvents}
          editable={true}
        />
      )}
      <StageNavigation
        backward={{
          text: 'Neustarten',
          handler: () => {
            resetAll(dispatch)
          },
        }}
        forward={{
          text: routes.REGISTRATIONS.longName,
          handler: () => {
            if (regs.length === 0) {
              dispatch(
                addToast({
                  type: ToastType.Danger,
                  title: 'Fehler',
                  body: 'Bitte wählen Sie mindestens eine Veranstaltung aus.',
                }),
              )
            } else {
              navigate(routes.REGISTRATIONS.path)
            }
          },
        }}
        hasRegistration={hasRegistration}
      />
    </>
  )
}

const resetAll = (dispatch: Dispatch<any>) => {
  const resetAction = createAction('reset')
  dispatch(resetAction())
  window.location.reload()
}

export default EventStage
